import { render, staticRenderFns } from "./homeSmall.vue?vue&type=template&id=09c721a6&scoped=true"
import script from "./homeSmall.vue?vue&type=script&lang=js"
export * from "./homeSmall.vue?vue&type=script&lang=js"
import style0 from "./homeSmall.vue?vue&type=style&index=0&id=09c721a6&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09c721a6",
  null
  
)

export default component.exports